import { PaperProps, SxProps } from "@mui/material";

export const sxAppBar: SxProps = {
  backgroundColor: 'rgba(255, 255, 255, 0.5)',
  backdropFilter: 'blur(12px)',
  boxShadow: 0,
  height: '92px',
  justifyContent: 'center',
  width: '100%',
  borderBottom: 0
}

export const sxAppBarContrast: SxProps = {
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  backdropFilter: 'blur(12px)',
  boxShadow: 0,
  height: '92px',
  justifyContent: 'center',
  width: '100%',
  borderBottom: 0
}

export const sxDrawer: Partial<PaperProps<React.ElementType<any>>> = {
  style: {
    width: '100%',
    padding: '24px'
  }
}
export const sxDrawerContrast: Partial<PaperProps<React.ElementType<any>>> = {
  style: {
    width: '100%',
    padding: '24px',
    backgroundColor: 'black'
  }
}